module.exports = __webpack_public_path__ + "img/ConcurrencyGifStarvation.1586bd6c.gif";